import { getLuminance } from '@mui/material/styles'
import { THEME_TYPE } from '@v4/constants/pages'
import { LUMINANCE_BOUNDARY } from '@v4/constants/theme'
import { SCORE_TYPE } from '@v4/constants/result'

export const isDarkColor = color => getLuminance(color) < LUMINANCE_BOUNDARY

export const defineTheme = (bgColor, defaultType = THEME_TYPE.LIGHT) => {
	try {
		return isDarkColor(bgColor) ? THEME_TYPE.DARK : THEME_TYPE.LIGHT
	} catch (e) {
		return defaultType
	}
}

export function createArray(length = 0, fill) {
	const arr = []
	const fillFunc = typeof fill === 'function' ? fill : i => i

	for (let i = 0; i < length; i += 1) {
		arr.push(fillFunc(i))
	}
	return arr
}

export const parseValidationError = errors => {
	if (Array.isArray(errors) && errors.length) {
		return errors[0]
	}

	if (!!errors && typeof errors === 'object') {
		return Object.entries(errors).reduce((acc, [key, value]) => {
			const keyArr = key.split('.')
			keyArr.reduce((subAcc, subKey, index) => {
				if (typeof subAcc === 'string') {
					return subAcc
				}
				if (typeof subAcc[subKey] === 'undefined') {
					// eslint-disable-next-line no-param-reassign
					subAcc[subKey] = typeof keyArr[index + 1] === 'undefined' ? parseValidationError(value) : {}
				}
				return subAcc[subKey]
			}, acc)

			return acc
		}, {})
	}

	return errors
}

export const parseScorePercent = value => {
	return _.clamp(Math.round((value || 0) * 100), 0, 100)
}

/**
 * @typedef {Object} Tier
 * @property {number} id - tier ID
 * @property {string} name - custom tier name
 * @property {string} score_colour - tier hex colour
 * @property {number} score_from - start of tier range
 * @property {number}  score_to - end of tier range
 */

/**
 * @param {Array<Tier>} tiers
 * @param {number} value - range from 0 to 100
 * @param {number|null} tierId - tier id
 * @return {Tier}
 */
export function getTier(tiers, value = 0, tierId = null) {
	return (tiers || []).find(({ score_to: to, id }) => {
		return tierId ? tierId === id : parseScorePercent(value) <= to
	})
}

export function getOverallScore(scores) {
	return (scores || []).find(({ type }) => type === SCORE_TYPE.TOTAL) || {}
}
